module.exports = __webpack_public_path__ + "static/media/sent.4fed104e.svg";